module.exports = __webpack_public_path__ + "static/media/mamabox.ba1cc2e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/lite/mamabox.png
// module id = 825
// module chunks = 20